import React, { useState } from "react";
import { useLoginStudent } from "../../../../hooks/api/Students/Auth/useLoginStudent";
import { Link, useNavigate } from "react-router-dom";
import { CloseEyes, OpenEyes } from "./StudentSignin";
import Button from "../../../../components/Button";

type Props = {};

const StudentSignInFlow = (props: Props) => {
  const [payload, setPayload] = useState({ email: "", password: "" });
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const navigate = useNavigate();

  const { mutateAsync: signin, isLoading } = useLoginStudent();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setPayload((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      await signin(payload);
      navigate("/student/overview");
    } catch (error) {
      console.error("Sign-in failed:", error);
    }
  };

  const isFormValid =
    payload.email.trim() !== "" && payload.password.trim() !== "";

  return (
    <div>
      <div className="w-full mb-5">
        <label htmlFor="email" className="text-gray700">
          Email
        </label>
        <input
          name="email"
          type="email"
          placeholder="Enter your email"
          className="border-[1px] rounded-md border-gray300 p-4 block mt-3 outline-none w-full"
          value={payload.email}
          disabled={isLoading}
          onChange={handleChange}
        />
      </div>
      <div className="">
        <label htmlFor="password" className="text-gray700">
          Password
        </label>
        <div className="relative">
          <input
            name="password"
            type={passwordVisibility ? "text" : "password"}
            placeholder="Enter your password"
            className="border-[1px] rounded-md border-gray300 p-4 block mt-3 outline-none w-full"
            value={payload.password}
            disabled={isLoading}
            onChange={handleChange}
          />
          <span
            className="absolute right-6 top-[18px] flex text-gray400 items-center text-sm cursor-pointer"
            onClick={() => setPasswordVisibility(!passwordVisibility)}
          >
            {passwordVisibility ? <OpenEyes /> : <CloseEyes />}
          </span>
        </div>
        <div className="text-right mt-2">
          <Link to="/student/reset" className="text-gray500">
            <span className="text-primary700 W2STMedium">Forgot Password?</span>
          </Link>
        </div>
      </div>
      <Button
        label="Sign In"
        isFormValid={isFormValid}
        isLoading={isLoading}
        handleSubmit={handleSubmit}
      />
      {/* <button
            className="block text-center mt-4 py-5 w-full mb-4 rounded-md text-white text-md bg-primary500"
            disabled={!isFormValid || isLoading}
            onClick={handleSubmit}
          >
            {isLoading ? "Submitting..." : "Sign In"}
          </button> */}
      {/* <p className="mt-10 text-gray500">
        By continuing, you agree to the Terms of Use, Privacy Policy, and
        Community Standards of Way2sucesstutors.
      </p> */}
      {/* <div className="text-center mt-10">
        <Link to="/student/signup" className="text-gray500">
          Do not have an account?{" "}
          <span className="text-primary700 W2STMedium">Signup</span>
        </Link>
      </div> */}
    </div>
  );
};

export default StudentSignInFlow;
